import { hydrateRoot } from 'react-dom/client';
import * as tracking from 'dibs-tracking';
import serverVars from 'server-vars';
import { IntlProvider } from 'dibs-react-intl';
import { ReactRelayContext } from 'react-relay/legacy.js';
import { designsRoot } from '../designs/designsRoot.js';
import { MOBILE } from 'dibs-buyer-layout/exports/deviceTypeEnums.ts';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { getRelayEnvironment } from '../utils/relayModernEnvironment.js';
import { createOperationDescriptor, getRequest } from 'relay-runtime';

// components
import { DesignsLayout } from '../designs/DesignsLayout.tsx';

const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

const variables = serverVars.get('relayVariables');
const operation = createOperationDescriptor(getRequest(designsRoot), variables);
const snapshot = environment.lookup(operation.fragment);

initializeDBL().then(() => {
    hydrateRoot(
        document.getElementById('js-root'),
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <ReactRelayContext
                value={{
                    variables,
                    environment,
                }}
            >
                <DesignsLayout
                    viewer={snapshot?.data?.viewer}
                    isMobile={serverVars.get('deviceType') === MOBILE}
                />
            </ReactRelayContext>
        </IntlProvider>
    );
    tracking.trackPageview();
});
